
import { Vue, Component, Prop } from "vue-property-decorator";
import { TheMask } from "vue-the-mask";

@Component({
  components: {
    TheMask,
  },
})
export default class MaskedPhoneInput extends Vue {
  @Prop({ type: String, required: true }) readonly value!: string;
  @Prop({ type: String, default: "+" }) readonly prefix!: string;
  @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  focused: boolean = false;

  get isDisabled(): string {
    return this.disabled ? "inputDisabled" : "";
  }
  handleInput(val: string): void {
    this.$emit("input", val);
  }

  handleChange() {
    this.$emit("touched");
  }

  handleFocus() {
    this.focused = true;
  }

  handleBlur() {
    this.focused = false;
  }

  get invalidClass(): object {
    return {
      "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300":
        this.invalid,
      "border-primary": this.focused,
    };
  }
}
